
import axios from 'axios';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import MenuPage from './MenuPage';
import Footer from './Footer';
const { ace } = window;

const NoticePage = () => {

    const { token } = useSelector((state) => state.AuthReducer);

    useEffect(() => {
        handleInit();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);


    const handleInit = async () => {
        const url = `https://ihongss.com/api/member/file_notice.json`;
        const headers = { "Content-Type": "application/json", "auth": token };
        const { data } = await axios.get(url, { headers });
        console.log(data);

        const contentData = document.getElementById('content_data');
        contentData.innerHTML = "";
        const cnt = 1;
        if (data.status === 200) {
            const html = window.marked.parse(data.doc.filedata);
            const markdownId = `markdown_${cnt}`;
            const markdownDiv = document.createElement('div');
            markdownDiv.id = markdownId;
            markdownDiv.className = 'markdown-body';
            markdownDiv.innerHTML = html;
            markdownDiv.style.padding = '10px';
            contentData.appendChild(markdownDiv);

            setTimeout(() => {
                window.Prism.highlightAll();
            }, 0);

            document.querySelectorAll(`#${markdownId} pre code.language-mermaid`).forEach((element) => {
                const code = element.textContent;
                const pre = element.parentElement;

                const mermaidDiv = document.createElement('div');
                mermaidDiv.className = 'mermaid';
                mermaidDiv.textContent = code;

                pre.replaceWith(mermaidDiv);
            });

            window.mermaid.run();

            /*
            var editor1 = ace.edit("editor1", {
                theme: "ace/theme/eclipse",
                mode: "ace/mode/java",
                maxLines: Infinity,
                wrap: true,

                fontSize: "16px",
                autoScrollEditorIntoView: true,
                showPrintMargin: false,
                keyboardHandler: "ace/keyboard/vscode",
            });

            editor1.setValue(data.doc.filedata);
            editor1.gotoLine(0, 0);

            editor1.setReadOnly(true);
            editor1.setHighlightActiveLine(false);
            editor1.setHighlightGutterLine(false);
            editor1.renderer.$cursorLayer.element.style.display = "none";
            */
        }
    };


    return (
        <div>
            <div className="card flex justify-content-center"
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1000,
                    background: '#f0f2f5',
                    paddingTop: '5px',
                    paddingBottom: '2px',
                }}
            >
                <div>
                    <MenuPage />
                </div>

                <hr />
            </div>

            <div className="container">
                <div className="row">
                    <div id="content_data">
                        <p>잠시만 기다려 주세요.</p>
                    </div>
                </div>
            </div>

            <Footer />

        </div>
    );
};

export default NoticePage;
